import firebase from 'firebase/app'
import {db} from '@/firebase'
import doctorRepository from '@/data/DoctorRepository'
import doctorOfficeRepository from '@/data/DoctorOfficeRepository'
import router from '@/router'
import i18n from '@/i18n'
import moment from 'moment'

export const actions = {

    setLoaded ({ commit }, payload) {
        commit('setLoaded', payload)
    },

    setPreventBodyScroll ({ commit }, payload) {
        commit('setPreventBodyScroll', payload)
    },

    setFrontLanguage ({ commit }, payload) {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('language', payload)
        }

        commit('SET_FRONT_LANGUAGE', payload)
    },

    setPatient ({ commit }, payload) {
        commit('SET_PATIENT', payload)
    },

    setPatientPosition ({ commit }, payload) {
        commit('SET_PATIENT_POSITION', payload)
    },

    setPatientPlace ({ commit }, payload) {
        commit('SET_PATIENT_PLACE', payload)
    },

    setPatientPlaceName ({ commit }, payload) {
        commit('SET_PATIENT_PLACE_NAME', payload)
    },

    setPatientMedicalPractice ({ commit }, payload) {
        commit('SET_PATIENT_MEDICAL_PRACTICE', payload)
    },

    setOnboardingStep ({ commit }, payload) {
        commit('setOnboardingStep', payload)
    },

    setLoading ({ commit }, payload) {
        commit('setLoading', payload)
    },

    setCurrentOffice ({ commit }, payload) {
        commit('setCurrentOffice', payload)
    },

    setCurrentDate ({ commit }, payload) {
        commit('setCurrentDate', payload)
    },

    setUserId ({ commit }, payload) {
        commit('setUserId', payload)
    },

    setDoctor ({ commit }, payload) {
        commit('setDoctor', payload)
    },

    setRecommendations ({ commit }, payload) {
        commit('setRecommendations', payload)
    },

    addNotification ({ commit }, payload) {
        commit('addNotification', payload)
    },

    disableNotification ({ commit }, payload) {
        commit('disableNotification', payload)
    },

    listenAppointments ({ commit }, payload) {
        commit('listenAppointments', payload)
    },

    setOffices ({ commit }, payload) {
        commit('setOffices', payload)
    },

    setOffice ({ commit }, payload) {
        commit('setOffice', payload)
    },

    setLocale ({ commit }, payload) {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('locale', payload)
        }

        i18n.locale = payload
        moment.locale(i18n.t('moment_locale'))
    },

    removeOffice ({ commit }, payload) {
        commit('removeOffice', payload)
    },

    setLanguages ({ commit }, payload) {
        commit('setLanguages', payload)
    },

    setCountries ({ commit }, payload) {
        commit('setCountries', payload)
    },

    setDefaultCountryId ({ commit }, payload) {
        commit('setDefaultCountryId', payload)
    },

    setFormError ({ commit }, payload) {
        commit('setFormError', payload)
    },

    logout ({ commit }, payload) {
        commit('setLoaded', false)
        commit('setLoading', true)
        commit('setUserId', null)
        commit('setDoctor', null)
        commit('setOffices', {})
        commit('setCurrentOffice', null)
        commit('setCurrentDate', null)

        firebase.auth().signOut().then(() => {
            window.location.reload()
            // router.push(payload)

            commit('setLoaded', true)
            commit('setLoading', false)
        })
    },

    createDoctor ({commit}, payload) {
        commit('setLoading', true)
        commit('setFormError', null)

        var doctor = payload.doctor
        var offices = payload.offices
        var userId = firebase.auth().currentUser.uid

        var batch = db.batch()

        var doctorRef = db.collection('doctors').doc(userId)

        var doctorDoc = {
            id: userId,
            countryId: doctor.countryId,
            lastName: doctor.lastName,
            firstName: doctor.firstName,
            contactEmail: doctor.contactEmail,
            inami: doctor.inami,
            language: doctor.language,
            avatar: doctor.avatar,
            isRegulated: doctor.isRegulated,
            isCertified: false,
            type: doctor.type,
            dateTimeCreated: new Date,
            onboardingStep: 0
        }

        batch.set(doctorRef, doctorDoc)

        var officeDocs = {}

        offices.forEach((item, index, array) => {
            var officeRef = db.collection('offices').doc()

            if (item.location == null) {
                item.location = new firebase.firestore.GeoPoint(process.env.DEFAULT_LAT, process.DEFAULT_LNG)
            }

            officeDocs[officeRef.id] = {
                countryId: item.countryId,
                doctorAvatar: doctor.avatar,
                doctorFirstName: doctor.firstName,
                doctorId: userId,
                doctorLastName: doctor.lastName,
                doctorType: doctor.type,
                id: officeRef.id,
                isDoctorRegulated: doctor.isRegulated,
                isEmergencyEmailAlertEnabled: true,
                locality: item.locality,
                location: item.location,
                name: item.name,
                phone: item.phone,
                streetName: item.streetName,
                streetNumber: item.streetNumber,
                zipCode: item.zipCode,
            }

            batch.set(officeRef, officeDocs[officeRef.id])
        })

        batch.commit()
            .then(() => {
                commit('setDoctor', doctorDoc)
                commit('setOffices', officeDocs)
                commit('setLoaded', true)
                commit('setLoading', false)

                router.push({
                    name: 'doctor.dashboard'
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

}



// WEBPACK FOOTER //
// ./src/store/actions.js